import { render, staticRenderFns } from "./Detail-Supplier.vue?vue&type=template&id=67f23981&"
import script from "./Detail-Supplier.vue?vue&type=script&lang=js&"
export * from "./Detail-Supplier.vue?vue&type=script&lang=js&"
import style0 from "./Detail-Supplier.vue?vue&type=style&index=0&id=67f23981&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports